// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"4c1da914","957":"10a14922"}[chunkId] + ".chunk.css";
};